import { defineRouting } from "next-intl/routing"

export const routing = defineRouting({
  // A list of all locales that are supported (normalized to two-letter slugs)
  locales: ["en", "es"],

  // Used when no locale matches
  defaultLocale: "es",
  localeDetection: true,
  localePrefix: "never",

  localeCookie: {
    maxAge: 60 * 60 * 24 * 365, // 1 year, instead of session-only default
  },

  // localized pahthnames
  pathnames: {
    "/": "/",
    "/chords": {
      en: "/chords",
      es: "/acordes",
    },
    "/chords/[slug]": {
      en: "/chords/[slug]",
      es: "/acordes/[slug]", // Only the "folder" is translated
    },
    "/press": {
      en: "/press",
      es: "/prensa",
    },
    "/privacy-policy": {
      en: "/privacy-policy",
      es: "/politica-de-privacidad",
    },
    "/cookie-policy": {
      en: "/cookie-policy",
      es: "/politica-de-cookies",
    },
    "/checkout": "/checkout",
    "/order": {
      en: "/order",
      es: "/pedido",
    },
    "/account": {
      en: "/account",
      es: "/cuenta",
    },
  },

  // Will be merged with the defaults
})

// Helper to map full locale codes (e.g. "en-US") to two-letter slugs ("en")
export const fullToShort = (fullLocale: string) => fullLocale.split("-")[0]
